import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Redirectpage.css';
import { BASEAPIURL, token } from "../../env";

const Redirectpage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [processing, setProcessing] = useState(true);
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const value = urlParams.get('redirectTo');
    const session = urlParams.get('SessionToken');
    const memberId = urlParams.get('MemID');
console.log(value,session,memberId);

    // Validate required parameters
    if (!value) {
      setProcessing(false);
      setError('No redirect target provided.');
      return;
    }

    if (!session || !memberId) {
      setProcessing(false);
      setError('Missing session or member ID.');
      return;
    }

    // Start progress simulation
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 10;
      });
    }, 200);

    // First API call: validate session and get member data
    const sessionApiUrl = `${BASEAPIURL}/MemberRedirectweb?Token=${token}&SessionToken=${session}&MemID=${memberId}`;

    fetch(sessionApiUrl, { method: "GET" })
      .then(res => {
        if (!res.ok) {
          throw new Error(`Session API failed with status ${res.status}`);
        }
        return res.json();
      })
      .then(data => {
        console.log('Session API Response:', data); // Debug log

        // Extract member info from the response
        const memberInfo = data.data || data; // Adjust based on actual structure

        const memberID = memberInfo.MemberID;
        const memberName = memberInfo.MemberName;
        const memberMSNO = memberInfo.Mem_MSNO;
        const memMobileNo = memberInfo.MemMobileNo;

        if (!memberID || !memberName || !memMobileNo) {
          throw new Error('Incomplete member data received.');
        }

        // Store data in sessionStorage
        sessionStorage.setItem('redirectValue', value);
        sessionStorage.setItem('MemberID', memberID);
        sessionStorage.setItem('MemberName', memberName);
        sessionStorage.setItem('MemberMSNO', memberMSNO);
        sessionStorage.setItem('MemMobileNo', memMobileNo);

        console.log('Data stored in sessionStorage:', {
          redirectValue: value,
          MemberID: memberID,
          MemberName: memberName,
          MemMobileNo: memMobileNo
        }); // Debug log

        // Navigate after a small delay
        // if(value == "bill"){
        //   setTimeout(() => {
        //     navigate(`/dashboard/${value}`);
        //   }, 500);
        // }else{
        //   setTimeout(() => {
        //     navigate(`/booking/${value}`);
        //   }, 500);
        // }
        setTimeout(() => {
  const route =
    value === "bill"
      ? `/dashboard/${value}`
      : `/booking/${value}`;

  navigate(route);
}, 500);

        setProcessing(false);
      })
      .catch(err => {
        console.error("API Error:", err);
        setError('Credentional has failed');
        setProcessing(false);
      });

    // Cleanup interval on unmount
    return () => clearInterval(interval);
  }, [location.search, navigate]);

  return (
    <div className="redirect-container">
      <div className="processing-card">
        <div className="animation-container">
          {processing ? (
            <>
              <div className="spinner"></div>
              <div className="progress-bar">
                <div 
                  className="progress-fill" 
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
              <p className="status-text">Processing redirect...</p>
            </>
          ) : error ? (
            <>
              <div className="error-icon">⚠️</div>
              <p className="error-text">{error}</p>
            </>
          ) : (
            <>
              <div className="checkmark">✓</div>
              <p className="success-text">Redirecting...</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Redirectpage;